<template>
  <div class="salary">
    <h3>薪资结构</h3>
    <span>公司为员工提供全面的、富有竞争力的薪资鼓励待遇。</span>
    <div class="icons">
      <el-card
        v-for="(item, index) in salaryIcons"
        :key="index"
         style="
          width: 13.75rem;
          height: 16.25rem;
          text-align: center;
          justify-content: center;"
        :style="{
          marginLeft: index == 0 ? '0rem' : '1.0625rem',
          backgroundColor: item.backgroundColor,
        }"
        shadow="hover"
        :body-style="{ padding: '0px' }">
        <div>
          <img
            :src="item.icon"
            alt
            style="
              width: 6.25rem;
              height: 6.25rem;
              margin-top: 2.5rem;
              margin-bottom:2.9375rem;
            "
          />
          <span
            style="
              font-size: 1.5rem;
              font-weight: bold;
              color: #1A1A1A;
              text-align: center;
              display: block;
            "
            >{{ item.title }}</span
          >
        </div>
      </el-card>
    </div>
  </div>
</template>

<style scoped>
.salary{
  padding: 0;
  margin: 0;
}
h3 {
  padding-top: 4.375rem;
  padding-bottom: 2.9375rem;
  color: #1A1A1A;
  font-size: 2.25rem;
  line-height: 3.75rem;
}

span{
  color: #777;
  font-size:1.5rem;
  line-height: 2.25rem;
}
.el-card{
  border-radius: 0px
}
.icons {
  position: relative;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: center;
  text-align: center;
  margin-top: 2.9375rem;
  margin-bottom: 4.375rem;
  margin-left: 1.75rem;
  margin-right: 1.75rem;
}
</style>
<script>
export default {
  data() {
    return {
      msg: "薪资结构",
      salaryIcons: [
        {
          icon: require("../../assets/welfare/ic_monthly_salary.png"),
          title: "月度工资",
          backgroundColor: "#F5E1E0",
        },
        {
          icon: require("../../assets/welfare/ic_double_pay.png"),
          title: "年底双薪",
          backgroundColor: "#E1F1F3",
        },
        {
          icon: require("../../assets/welfare/ic_annual_bonus.png"),
          title: "年度奖金",
          backgroundColor: "#ECF3DC",
        },
      ],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/mobile/Salary.vue